// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"1e7cf6c3","654":"d6980f86","879":"d6980f86","966":"5bac36a5"}[chunkId] + ".chunk.css";
};